export default __webpack_public_path__ + "static/media/apple.2797c703.png";